import * as echarts from 'echarts/core';
import { BarChart } from 'echarts/charts';
import {
  TitleComponent,
  GridComponent,
  LegendComponent,
  TooltipComponent,
  MarkLineComponent,
} from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import { useEffect, useRef } from 'react';
import { useSize } from 'ahooks';

echarts.use([
  LegendComponent,
  TitleComponent,
  GridComponent,
  TooltipComponent,
  MarkLineComponent,
  CanvasRenderer,
  BarChart,
]);

interface Props {
  data: Array<number>;
}

const BarPT: React.FC<Props> = ({ data }: Props) => {
  const chartRef = useRef<HTMLDivElement>(null);
  const chartInstance = useRef<echarts.ECharts | null>(null);
  const size = useSize(document.body);

  useEffect(() => {
    const seriesData =
      data.length > 0 ? data : [4, 3, 5, 3, 4, 6, 3, 2, 4, 3, 5, 4];

    const option: any = {
      tooltip: {
        trigger: 'axis',
      },
      grid: {
        containLabel: true,
      },
      xAxis: {
        type: 'category',
        data: [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec',
        ],
        name: 'MONTH',
        nameLocation: 'middle',
        nameGap: 30,
        nameTextStyle: {
          color: '#999',
          fontSize: 11,
          fontWeight: 500,
          letterSpacing: 0.5,
        },
        axisTick: { show: false },
        axisLine: {
          lineStyle: {
            color: '#EAEAEA',
          },
        },
        axisLabel: {
          color: '#545454b3',
        },
      },
      yAxis: {
        type: 'value',
        name: 'COUNT',
        nameLocation: 'middle',
        nameGap: 30,
        nameTextStyle: {
          color: '#999',
          fontSize: 11,
          fontWeight: 500,
          letterSpacing: 0.5,
        },
        min: 0,
        max: 8,
        interval: 2,
        splitLine: {
          lineStyle: {
            type: 'dashed',
            color: '#E8E8E8',
          },
        },
      },
      series: [
        {
          name: 'PT',
          type: 'bar',
          data: seriesData,
          itemStyle: {
            color: '#722ED1',
            borderRadius: [4, 4, 0, 0],
          },
          barWidth: '40%',
          markLine: {
            silent: true,
            symbol: 'none',
            lineStyle: {
              type: 'dashed',
              color: '#FF4D4F',
            },
            label: {
              formatter: 'Avg: 3.8',
              position: 'insideEndTop',
            },
            data: [{ yAxis: 3.8 }],
          },
        },
      ],
    };

    if (!chartInstance.current) {
      chartInstance.current = echarts.init(
        chartRef.current as unknown as HTMLDivElement,
        undefined,
        { height: 400 },
      );
    }
    chartInstance.current?.setOption(option);
  }, [data]);

  useEffect(() => {
    chartInstance.current?.resize();
  }, [size]);

  return <div ref={chartRef} />;
};

export default BarPT;
